var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('primary-btn',{attrs:{"color":"#323232","to":_vm.to,"outlined":true,"disabled":_vm.disabled},on:{"click":_vm.click}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }